// extracted by mini-css-extract-plugin
var _1 = "SearchLoader-moduleSearchLoader__fjUW5";
var _2 = "SearchLoader-moduletext__Dub3Q Text-moduletext__Z2j5F";
export { _1 as "SearchLoader", _2 as "text" }
